<script setup lang="ts" generic="T extends string">
  /**
   * Badges & chips — 03-components/07-badges-chips · OSCloud DS 1.1.154
   */
  import BfChip from './BfChip.vue'

  withDefaults(defineProps<{ modelValue: T; options: { value: T; label: string }[]; labelledby?: string }>(), {
    labelledby: undefined,
  })

  defineEmits<{ 'update:modelValue': [value: T] }>()
</script>

<template>
  <div class="filter-chip-group" role="group" :aria-labelledby="labelledby">
    <BfChip
      v-for="option in options"
      :key="option.value"
      :active="modelValue === option.value"
      @click="$emit('update:modelValue', option.value)"
    >
      {{ option.label }}
    </BfChip>
  </div>
</template>

<style scoped lang="scss">
  .filter-chip-group {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--bf-sp-1);
  }
</style>
